// @ts-nocheck
import { Card, CardContent, CardHeader, CardTitle } from 'shared/ui/card'
import { Button } from 'shared/ui/button'
import { Construction, ArrowLeft } from 'lucide-react'

interface PlaceholderPageProps {
  title: string
  description: string
  onBack?: () => void
}

export function PlaceholderPage({ title, description, onBack }: PlaceholderPageProps) {
  return (
    <div className="space-y-6">
      {onBack && (
        <Button variant="ghost" onClick={onBack} className="mb-4">
          <ArrowLeft className="w-4 h-4 mr-2" />
          กลับ
        </Button>
      )}
      
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Construction className="w-6 h-6 text-orange-500" />
            {title}
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-center py-12">
            <Construction className="w-16 h-16 text-gray-300 mx-auto mb-4" />
            <h3 className="text-lg font-medium text-gray-900 mb-2">
              หน้านี้อยู่ระหว่างการพัฒนา
            </h3>
            <p className="text-gray-500 mb-6 max-w-md mx-auto">
              {description}
            </p>
            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 max-w-md mx-auto">
              <p className="text-sm text-yellow-800">
                <strong>Coming Soon:</strong> ฟีเจอร์นี้จะพร้อมใช้งานในเวอร์ชันถัดไป
              </p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}


